import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import "../../styles/users/users.scss";
import { utcToLocal } from "../../utils/dateConvert";
import RoleAccessBadge from "../common/roleAccessBadge";
import "../../styles/common/groupAllocation.scss";
var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetail: [],
      timeZone: [],
      roles: ["Community Manager", "Distributor", "System Admin", "User"],
      userID: "",
      customerID: "default",
      customerName: "",
      time: "default",
      timeSelected: "",
      name: "",
      description: "",
      role: "default",
      status: "Active",
      email: "",
      password: "",
      confpassword: "",
      realTimeValidation: true,
      emailVerification: "",
      customerID_error: false,
      time_error: false,
      name_error: false,
      role_error: false,
      email_error: false,
      emailformat_error: false,
      password_error: false,
      passwordlength_error: false,
      confpassword_error: false,
      originalRole: "default",
      showSystemAdminWarning: false,
      pendingRole: "",
      isPrivate: false,
      groupAllocationGroups: [],
      groupAllocationSelectedIds: [],
      groupAllocationSavedIds: [],
      groupAllocationLoading: false,
      groupAllocationSaving: false,
      groupAllocationMessage: "",
      groupAllocationError: "",
    };
    this.formSubmit = false;
  }
  async componentDidMount() {
    console.log(this.props.match.params.id);
    let userId = this.props.match.params.id;
    this.setState({ userID: userId });
    //Get all customer id
    this.props.setLoadingPageAction(true);

    try {
      const userDetail = await axios.get(
        `${apiHost}/api/Auth/UpdateUsers/${userId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ userDetail: userDetail.data });
      this.setState({
        customerID: userDetail.data.customerId,
        customerName: userDetail.data.customerName,
        description: userDetail.data.description,
        // timeSelected:userDetail.data.timezone_City,
        time: userDetail.data.timeZoneId,
        name: userDetail.data.userName,
        role: userDetail.data.userType,
        originalRole: userDetail.data.userType,
        status: userDetail.data.status || "Active",
        isPrivate: !!userDetail.data.isPrivate,
        email: userDetail.data.email,
        emailVerification: userDetail.data.email,
      });
      if (this.canManageUserGroups()) {
        await this.getUserGroupAllocation(userId);
      }
      console.log("user id", userDetail.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    //   Get all Time zone

    this.props.setLoadingPageAction(true);

    try {
      const timeZone = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ timeZone: timeZone.data });
      console.log("timedfgdfgdZone ", timeZone.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    //Get all Roles
    this.props.setLoadingPageAction(true);

    try {
      const roles = await axios.get(`${apiHost}/api/auth/AllRoles`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({ roles: roles.data });
      console.log("roles ", roles.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  handleCustomeridChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ customerID_error: true });
    } else {
      this.setState({ customerID_error: false });
    }
    this.setState({ customerID: e.target.value });
  }
  handleTimeChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ time_error: true });
    } else {
      this.setState({ time_error: false });
    }
    this.setState({ time: e.target.value, timeSelected: e.target.value });
  }
  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleRoleChange(e) {
    console.log("e.target.value", e.target.value);
    const selectedRole = e.target.value;
    if (selectedRole == "default") {
      this.setState({ role_error: true });
    } else {
      this.setState({ role_error: false });
    }

    if (selectedRole === "SystemAdmin" && this.state.role !== "SystemAdmin") {
      this.setState({
        showSystemAdminWarning: true,
        pendingRole: selectedRole,
      });
      return;
    }

    this.setState({ role: selectedRole });
  }
  confirmSystemAdminRole = () => {
    this.setState({
      role: this.state.pendingRole || "SystemAdmin",
      pendingRole: "",
      showSystemAdminWarning: false,
      role_error: false,
    });
  }
  cancelSystemAdminRole = () => {
    this.setState({
      pendingRole: "",
      showSystemAdminWarning: false,
    });
  }
  handleStatusChange(e) {
    this.setState({ status: e.target.value });
  }
  handleEmailChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      // this.setState({emailformat_error:false})
      this.setState({ email_error: true });
    } else if (!e.target.value.match(mailformat)) {
      // this.setState({emailformat_error:true})
      this.setState({ email_error: false });
    } else {
      // this.setState({emailformat_error:false})
    }
    this.setState({ email: e.target.value });
  }
  handlePasswordChange(e) {
    console.log("e.target.value", e.target.value);
    // if(e.target.value=='' ){
    //     this.setState({passwordlength_error:false})

    //     this.setState({password_error:true})

    // }else
    // if (e.target.value.length < 6 || e.target.value.length > 15) {
    //   this.setState({ password_error: false });
    //   this.setState({ passwordlength_error: true });
    // } else {
    //   this.setState({ passwordlength_error: false });
    // }
    this.setState({ password: e.target.value });
  }
  handleConfirmPasswordChange(e) {
    if (e.target.value !== this.state.password) {
      this.setState({ confpassword_error: true });
    } else {
      this.setState({
        confpassword_error: false,
        confpassword: e.target.value,
      });
    }
  }
  async handleSubmit() {
    this.formSubmit = true;
    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }
    if (this.state.time == "default") {
      this.setState({ time_error: true });
      this.formSubmit = false;
    }
    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }
    if (this.state.role == "default") {
      this.setState({ role_error: true });
      this.formSubmit = false;
    }
    if (this.state.email == "") {
      this.setState({ email_error: true });
      this.formSubmit = false;
    } else if (!this.state.realTimeValidation) {
      this.formSubmit = false;
    }
    // if(this.state.password==""){
    //     this.setState({password_error:true})
    //     this.setState({formSubmit:false})

    // } else if(this.state.confpassword==""){
    //     this.setState({confpassword_error:true})
    //     this.setState({formSubmit:false})
    // }

    if (this.formSubmit) {
      // console.log("apiobj",apiObj);
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/auth/Update`,
          {
            Id: this.state.userID,
            UserName: this.state.name,
            Description: this.state.description,
            Password: this.state.password,
            CustomerId: this.state.customerID,
            TimezoneId: this.state.time,
            Email: this.state.email,
            UserType: [this.state.role],
            Status: this.state.status,
            IsPrivate: localStorage.getItem("role") === "SystemAdmin" && this.state.isPrivate,
            dbUpdated: this.state.userDetail.dbUpdated,
            dbCreated: this.state.userDetail.dbCreated,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        console.log("customer id", response.data);
        // this.props.history.push('/users')
        this.props.history.goBack();
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          if (e.response.data.statusCode == "1") {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }
  handleDescription = (e) => {
    console.log("e.target.value", e.target.value);
    this.setState({ description: e.target.value });
  };
  handlePrivateChange = (e) => {
    this.setState({ isPrivate: e.target.checked });
  };
  canManageUserGroups = () => {
    const role = String(localStorage.getItem("role") || "").replace(/\s+/g, "").toLowerCase();
    return ["systemadmin", "vtdemo", "communitymanager"].includes(role);
  };
  getUserGroupAllocation = async (userId = this.state.userID) => {
    if (!userId) {
      return;
    }

    this.setState({
      groupAllocationLoading: true,
      groupAllocationError: "",
      groupAllocationMessage: "",
    });

    try {
      const response = await axios.get(`${apiHost}/api/Group/UserGroupAllocation/${userId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      const groups = response.data.groups || response.data.Groups || [];
      const selectedIds = response.data.groupIds || response.data.GroupIds ||
        groups.filter((group) => group.isMember || group.IsMember).map((group) => group.id || group.Id);

      const selectedIdStrings = selectedIds.map((id) => id.toString());
      this.setState({
        groupAllocationGroups: groups,
        groupAllocationSelectedIds: selectedIdStrings,
        groupAllocationSavedIds: selectedIdStrings,
        groupAllocationLoading: false,
      });
    } catch (e) {
      if (e.response && e.response.status === 401) {
        this.props.history.push("/login");
      } else {
        this.setState({
          groupAllocationError: "Unable to load group allocation.",
          groupAllocationLoading: false,
        });
      }
    }
  };
  toggleGroupAllocation = (groupId) => {
    const groupIdText = groupId.toString();
    this.setState((state) => ({
      groupAllocationMessage: "",
      groupAllocationError: "",
      groupAllocationSelectedIds: state.groupAllocationSelectedIds.includes(groupIdText)
        ? state.groupAllocationSelectedIds.filter((id) => id !== groupIdText)
        : [...state.groupAllocationSelectedIds, groupIdText],
    }));
  };
  handleSelectAllGroups = () => {
    this.setState((state) => ({
      groupAllocationMessage: "",
      groupAllocationError: "",
      groupAllocationSelectedIds: state.groupAllocationGroups.map((group) => (group.id || group.Id).toString()),
    }));
  };
  handleClearGroups = () => {
    this.setState({
      groupAllocationMessage: "",
      groupAllocationError: "",
      groupAllocationSelectedIds: [],
    });
  };
  handleSaveGroupAllocation = async () => {
    this.setState({
      groupAllocationSaving: true,
      groupAllocationError: "",
      groupAllocationMessage: "",
    });

    try {
      const response = await axios.post(
        `${apiHost}/api/Group/UpdateUserGroupAllocation`,
        {
          userId: this.state.userID,
          groupIds: this.state.groupAllocationSelectedIds,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const groups = response.data.groups || response.data.Groups || [];
      const selectedIds = response.data.groupIds || response.data.GroupIds || [];

      const selectedIdStrings = selectedIds.map((id) => id.toString());
      this.setState({
        groupAllocationGroups: groups,
        groupAllocationSelectedIds: selectedIdStrings,
        groupAllocationSavedIds: selectedIdStrings,
        groupAllocationSaving: false,
        groupAllocationMessage: "Group allocation saved.",
      });
    } catch (e) {
      if (e.response && e.response.status === 401) {
        this.props.history.push("/login");
      } else {
        this.setState({
          groupAllocationSaving: false,
          groupAllocationError: "Unable to save group allocation.",
        });
      }
    }
  };
  realTimeUserValidation = async (e) => {
    if (e.target.value != this.state.emailVerification) {
      try {
        let response = await axios.get(
          `${apiHost}/api/Auth/IsEmailExist?Email=${encodeURIComponent(e.target.value)}&userId=${encodeURIComponent(this.state.userID)}`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        console.log("response", response.data);
        this.setState({ realTimeValidation: true });
      } catch (e) {
        this.setState({ realTimeValidation: false });

        console.log(
          `Axios request failed.Error logged on Realtime User Check${e}`
        );
      }
    } else {
      this.setState({ realTimeValidation: true });
    }
  };

  render() {
    console.log("this.state.timeSelected", this.state.timeSelected);
    const isSystemAdmin = localStorage.getItem("role") === "SystemAdmin";
    const canManageUserGroups = this.canManageUserGroups();
    const {
      groupAllocationGroups,
      groupAllocationSelectedIds,
      groupAllocationSavedIds,
      groupAllocationLoading,
      groupAllocationSaving,
      groupAllocationMessage,
      groupAllocationError,
    } = this.state;
    const hasPendingGroupAllocationChanges =
      [...groupAllocationSelectedIds].sort().join(",") !==
      [...groupAllocationSavedIds].sort().join(",");
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit User </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper user-create-page">
              <div className="user-create-header">
                <div>
                  <span className="user-create-kicker">User editor</span>
                  <h2>{this.state.name || "Edit User"}</h2>
                  <div className="user-create-subtitle">
                    <span>{this.state.customerName || "Customer"}</span>
                    <span>{this.state.role === "default" ? "Select role" : this.state.role}</span>
                    <span className={this.state.status === "Active" ? "record-badge-active" : "record-badge-disabled"}>
                      {this.state.status === "Active" ? "Active" : "Disabled"}
                    </span>
                  </div>
                </div>
                <div className="user-create-actions">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                    disabled={!this.state.realTimeValidation}
                  >
                    Save Changes
                  </Button>
                </div>
              </div>

              <Form className="user-create-form-modern">
                <section className="user-create-section">
                  <div className="user-create-section-title">
                    <h3>Account Scope</h3>
                    <p>Customer, timezone, status and role assignment for this user.</p>
                  </div>
                  <div className="user-create-grid">
                    <Form.Group controlId="editUserCustomer">
                      <Form.Label>Customer</Form.Label>
                      <Form.Control type="text" value={this.state.customerName || ""} disabled />
                      <p style={this.state.customerID_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Customer field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="editUserTimeZone">
                      <Form.Label>Time Zone</Form.Label>
                      <Form.Control
                        as="select"
                        value={this.state.time}
                        onChange={this.handleTimeChange.bind(this)}
                      >
                        <option value="default">Select Time Zone</option>
                        {this.state.timeZone.map((time, index) => {
                          return (
                            <option key={index} value={time.timeZonesId}>
                              {time.timeZoneCity}
                            </option>
                          );
                        })}
                      </Form.Control>
                      <p style={this.state.time_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Time Zone field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="editUserStatus">
                      <Form.Label>Status</Form.Label>
                      <Form.Control
                        as="select"
                        value={this.state.status}
                        onChange={this.handleStatusChange.bind(this)}
                      >
                        <option value="Active">Active</option>
                        <option value="Disabled">Disabled</option>
                      </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="editUserRole">
                      <Form.Label>Role</Form.Label>
                      <Form.Control
                        as="select"
                        value={this.state.role}
                        onChange={this.handleRoleChange.bind(this)}
                      >
                        <option value="default">Select Role</option>
                        {this.state.roles.map((role, index) => {
                          return (
                            <option key={index} value={role.roleName}>{role.roleName}</option>
                          );
                        })}
                      </Form.Control>
                      <p style={this.state.role_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Role field is required.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                {canManageUserGroups && (
                  <section className="user-create-section">
                    <div className="user-create-section-title user-group-allocation-title">
                      <div>
                        <h3>Group Allocation</h3>
                        <p>Add or remove this user from groups available to your account.</p>
                      </div>
                      <RoleAccessBadge role="CommunityManager" />
                      <div className="user-group-allocation-actions">
                        <Button
                          variant="outline-secondary"
                          type="button"
                          onClick={this.handleSelectAllGroups}
                          disabled={groupAllocationLoading || groupAllocationSaving || groupAllocationGroups.length === 0}
                        >
                          All
                        </Button>
                        <Button
                          variant="outline-secondary"
                          type="button"
                          onClick={this.handleClearGroups}
                          disabled={groupAllocationLoading || groupAllocationSaving}
                        >
                          None
                        </Button>
                        <Button
                          className={hasPendingGroupAllocationChanges ? "group-allocation-save-pending" : ""}
                          variant="primary"
                          type="button"
                          onClick={this.handleSaveGroupAllocation}
                          disabled={groupAllocationLoading || groupAllocationSaving}
                        >
                          {groupAllocationSaving ? "Saving..." : "Save Groups"}
                        </Button>
                      </div>
                    </div>
                    <div className="user-group-allocation-notice">
                      This is an organisational visibility setting. Group membership controls which assets and information this user can access.
                    </div>
                    <div className="user-group-allocation-summary">
                      <strong>{groupAllocationSelectedIds.length}</strong> of <strong>{groupAllocationGroups.length}</strong> available groups selected
                    </div>
                    {groupAllocationLoading ? (
                      <div className="user-group-allocation-empty">Loading groups...</div>
                    ) : groupAllocationGroups.length === 0 ? (
                      <div className="user-group-allocation-empty">No groups available to your account for this user.</div>
                    ) : (
                      <div className="user-group-allocation-grid">
                        {groupAllocationGroups.map((group) => {
                          const groupId = (group.id || group.Id || "").toString();
                          const groupName = group.name || group.Name || "Group";
                          const groupStatus = group.status || group.Status || "";
                          const isSelected = groupAllocationSelectedIds.includes(groupId);

                          return (
                            <label className={`user-group-allocation-item ${isSelected ? "selected" : ""}`} key={groupId}>
                              <input
                                checked={isSelected}
                                onChange={() => this.toggleGroupAllocation(groupId)}
                                type="checkbox"
                              />
                              <span>
                                <strong>{groupName}</strong>
                                {groupStatus && <small>{groupStatus}</small>}
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    )}
                    {groupAllocationMessage && <p className="user-group-allocation-message">{groupAllocationMessage}</p>}
                    {groupAllocationError && <p className="user-group-allocation-error">{groupAllocationError}</p>}
                  </section>
                )}

                <section className="user-create-section">
                  <div className="user-create-section-title">
                    <h3>User Details</h3>
                    <p>Identity, email and profile notes for this user.</p>
                  </div>
                  <div className="user-create-grid">
                    <Form.Group controlId="editUserName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.name}
                        onChange={this.handleNameChange.bind(this)}
                      />
                      <p style={this.state.name_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Name field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="editUserEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={this.state.email}
                        onChange={(e) => {
                          this.handleEmailChange(e);
                          this.realTimeUserValidation(e);
                        }}
                      />
                      <p style={this.state.email_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Email field is required.
                      </p>
                      <p style={this.state.emailformat_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Email field is not a valid e-mail address.
                      </p>
                      {this.state.email != "" && (
                        <p style={!this.state.realTimeValidation ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                          Email already in use
                        </p>
                      )}
                    </Form.Group>

                    <Form.Group className="user-create-wide" controlId="editUserDescription">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        value={this.state.description}
                        rows="3"
                        onChange={this.handleDescription}
                      />
                    </Form.Group>

                    {isSystemAdmin && (
                      <Form.Group className="user-create-wide user-private-toggle" controlId="editUserPrivate">
                        <Form.Check
                          checked={this.state.isPrivate}
                          label="Private simulation account"
                          onChange={this.handlePrivateChange}
                          type="checkbox"
                        />
                        <p>Hidden from Community Managers. Visible to System Admin and VtDemo accounts.</p>
                      </Form.Group>
                    )}
                  </div>
                </section>

                <section className="user-create-section">
                  <div className="user-create-section-title">
                    <h3>Security</h3>
                    <p>Optional password update for this account.</p>
                  </div>
                  <div className="user-create-grid">
                    <Form.Group controlId="editUserPassword">
                      <Form.Label>Password</Form.Label>
                      <Form.Control type="text" onChange={this.handlePasswordChange.bind(this)} />
                      <p style={this.state.password_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Password field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="editUserConfirmPassword">
                      <Form.Label>Confirm Password</Form.Label>
                      <Form.Control type="text" onChange={this.handleConfirmPasswordChange.bind(this)} />
                      <p style={this.state.confpassword_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The password and confirmation password do not match.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                <div className="user-edit-meta">
                  <div>
                    <span>Created</span>
                    <strong>
                      {this.state.userDetail.dbCreated
                        ? utcToLocal(this.state.userDetail.dbCreated)
                        : "Not created"}
                    </strong>
                  </div>
                  <div>
                    <span>Updated</span>
                    <strong>
                      {this.state.userDetail.dbUpdated
                        ? utcToLocal(this.state.userDetail.dbUpdated)
                        : "Not updated"}
                    </strong>
                  </div>
                </div>

                <div className="user-create-footer">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                    disabled={!this.state.realTimeValidation}
                  >
                    Save Changes
                  </Button>
                </div>
              </Form>
            </div>
          </div>
          <Modal
            className="user-admin-warning-modal"
            centered
            show={this.state.showSystemAdminWarning}
            onHide={this.cancelSystemAdminRole}
          >
            <Modal.Header closeButton>
              <Modal.Title>System Administrator Privileges</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Are you sure you want to give this user System Administrator privileges?
              </p>
              <p>
                This will grant system wide access and should be reserved only for Visiontrak Admin/Staff.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={this.cancelSystemAdminRole}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.confirmSystemAdminRole}>
                Confirm Privileges
              </Button>
            </Modal.Footer>
          </Modal>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
